import { useRef } from "react";
import { useParams } from "react-router-dom";

import { sendMessage } from "../api/firebase/firebaseChat";
import { useGetChatMessages } from "./useGetChatMessages";
import { useProfileData } from "../../../hooks/useProfileData";

export const useChatThread = () => {
  const { chatId } = useParams();
  const { messages, isMessagesLoading } = useGetChatMessages([]);
  const { data } = useProfileData();
  const chatInputRef = useRef<HTMLInputElement>(null);

  const handleOnKeyDownWithinChatInput = async (event: React.KeyboardEvent) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      await handleSendTextMessage();
    }
  };

  const handleSendTextMessage = async () => {
    const messageText = chatInputRef.current?.value?.trim();
    if (!messageText) return;

    await sendTextMessage(messageText);
    if (chatInputRef.current) {
      chatInputRef.current.value = "";
    }
  };

  const sendTextMessage = async (text: string) => {
    if (!text.trim() || !chatId || !data.id) return;

    try {
      await sendMessage(chatId, text.trim(), data.id);
    } catch (error) {
      console.error("Error sending message:", error);
      throw error;
    }
  };

  return {
    messages,
    isMessagesLoading,
    chatInputRef,
    handleSendTextMessage,
    handleOnKeyDownWithinChatInput,
    chatId,
  };
};
